import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';

import EventCard from 'components/UI/Event/EventCard';

const EventCardStyled = withStyles((theme) => ({
  root: {
  },
}))(EventCard);

class EventCardWrapper extends Component {
  render() {
    const { $$item, itemIndex, classes, kind, variant, isSubscribed } = this.props;
        
    return <EventCardStyled 
      $$item={$$item}
      itemIndex={itemIndex}
      kind={kind}
      variant={variant}
      isSubscribed={isSubscribed}
    />;
  }
}

export default EventCardWrapper;



// WEBPACK FOOTER //
// ./src/components/Event/EventCard.jsx